<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-card >
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
            <div  v-else class="address">
                <b-form inline class="formBox"> 
                    <b-form-group class="inputGrp" label-for="country">
                        <b-form-select 
                            class="select"
                            style="min-width: 300px"
                            v-model="selectedProtocol"
                            text-field="name"
                            value-field="id"
                            :options="protocols"
                            :select-size="10"
                        />
                        <div class="buttons">
                            <b-button variant="primary" :title="$t('general.newCountry')" @click="openModal(true,'add')" >
                                 <b-icon icon="file-earmark-plus-fill"></b-icon> 
                            </b-button>
                            <b-button variant="success" :title="$t('general.edit')" @click="openModal(true,'edit', protocol)"> 
                                <b-icon icon="pen-fill"  ></b-icon> 
                            </b-button>
                            <b-button variant="warning" title="Format Kopyalama" @click="openModal(true,'copyProtocol', protocol)"> 
                                <b-icon icon="files"  ></b-icon> 
                            </b-button>
                            <b-button variant="danger" :title="$t('general.delete')" @click="openModal(true,'delete', protocol)"> 
                                <b-icon icon="trash" ></b-icon> 
                            </b-button>
                        </div>
                    </b-form-group>
                    
                    <div style="flex:1" v-if="Object.keys(protocol).length > 0">
                        <div class="buttons" style="margin: 1rem;">
                            <b-button :title="$t('general.add')" variant="success" @click="openModal(true,'addFormat', protocol)"> {{$t('general.add')}} </b-button>
                        </div>
                        <b-table-simple hover responsive style="height: 500px; overflow-y: scroll;">
                            <b-thead>
                                <b-th> Format Kodu </b-th>
                                <b-th> İsim </b-th>
                                <b-th> Direkt İşle </b-th>
                                <b-th> İşlemler </b-th>
                            </b-thead>
                            <b-tbody>
                                <b-tr v-for="item in formats" :key="item.id">
                                <b-td>{{item.format}}</b-td>
                                <b-td>{{item.name}}</b-td>
                                <b-td>
                                    <b-badge :variant="item.direct_process ?'success':'danger'"> {{item.direct_process ?'Direkt İşle':'Ayarlara Göre İşle'}} </b-badge></b-td>
                                <b-td>
                                    <b-icon icon="pencil-square" variant="primary" scale="1.25" shift-v="1.25" aria-hidden="true"  @click="openModal(true,'editFormat', {modalType:'format',item})"  ></b-icon>
                                    <b-icon icon="trash" variant="danger" scale="1.25" shift-v="1.25" aria-hidden="true" @click="openModal(true, 'delete', {modalType:'format',item})"></b-icon>
                                </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </div>
                </b-form>
            </div>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Modals from './modals/';


    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.protocolSettings'), url: "/Defination/ReceiverFormats" },

    ]
    export default {
        name: "ReceiverProtocol",
        created:function(){
            this.$store.dispatch('listRecProtocols')
        },
        computed: {
            protocols(){
                return this.$store.getters.getReceiverProtocols
            },
            formats(){
                return this.$store.getters.getProtocolFormats
            },
            loading(){
                return this.$store.getters.getDefinationLoading
            }
        },
        watch: {
            selectedProtocol(){
                this.$store.dispatch('listFormats', this.selectedProtocol)
                this.protocol = this.$store.getters.getReceiverProtocols.find(p => p.id === this.selectedProtocol)
            },
        },
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"ReceiverProtocol",
                modalName: "",
                selectedProtocol: null, 
                protocol: {},        
            }
        },
        components:{
            BreadCrumb, Modals
        },
        methods:{
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/address.min.css"; 
</style>

<!--

-->


// WEBPACK FOOTER //
// src/pages/General/Defination/RecProtocol.vue